import { Injectable, Optional } from '@angular/core';
import { NotifyService, NotifyOptions } from '@farris/ui-notify';
import { LanguageService } from './languag.service';

/**
 * éç¥æå¡
 * @scope FormModule
 * @description
 * æ¶æ¯æç¤ºä½¿ç¨ç­ç¥ï¼æåä½¿ç¨successï¼å¤±è´¥ä½¿ç¨errorï¼è­¦åä½¿ç¨warningï¼å¶ä»åºæ¯ä½¿ç¨info
 */
@Injectable()
class FormNotifyService {

  /**
   * æé å½æ°
   * æ³¨å¥@farris/uiçNotifyService
   */
  constructor(private notifyService: NotifyService,
    @Optional() private languageService: LanguageService
  ) {
    if (!languageService) {
      this.languageService = LanguageService.getInstance();
    }
  }

  /**
   * ä¿¡æ¯æç¤º
   * @param content åå®¹
   */
  public default(content: string) {
    return this.notifyService.default(<NotifyOptions>{
      title: this.languageService.notifyTitle,
      msg: content,
      timeout: 3000
    });
  }

  /**
   * ä¿¡æ¯æç¤º
   * @param content åå®¹
   */
  public info(content: string, options?: { [prop: string]: any }) {
    const notifyOptions: NotifyOptions = {
      title: this.languageService.notifyTitle,
      msg: content,
      timeout: 3000
    } as NotifyOptions;
    if (options && options.hideTitle) {
      delete notifyOptions.title;
    }
    return this.notifyService.info(notifyOptions);
  }

  /**
   * æåæç¤º
   * @param content åå®¹
   * @param options? éé¡¹ {shorTitle: false}
   */
  public success(content: string, options?: { [prop: string]: any }) {
    const notifyOptions: NotifyOptions = {
      title: this.languageService.notifyTitle,
      msg: content,
      timeout: 3000
    } as NotifyOptions;
    if (options && options.hideTitle) {
      delete notifyOptions.title;
    }
    this.notifyService.success(notifyOptions);
  }

  /**
   * è­¦åæç¤º
   * @param content åå®¹
   * @param options éé¡¹
   */
  public warning(content: string, options?: { [prop: string]: any }) {
    const notifyOptions: NotifyOptions = {
      title: this.languageService.notifyTitle,
      msg: content,
      timeout: 3000
    } as NotifyOptions;
    if (options && options.hideTitle) {
      delete notifyOptions.title;
    }
    this.notifyService.warning(notifyOptions);
  }

  /**
   * éè¯¯æç¤º
   * @param content åå®¹
   */
  public error(content: string, options?: { [prop: string]: any }) {
    const notifyOptions: NotifyOptions = {
      title: this.languageService.notifyTitle,
      msg: content,
      timeout: 3000
    } as NotifyOptions;
    if (options && options.hideTitle) {
      delete notifyOptions.title;
    }
    this.notifyService.error(notifyOptions);
  }
}

export { FormNotifyService };
